// src/i18n/en/control.ts
// English counterpart of `i18n/es/control.ts` — see there for context.
export const control = {
  name: 'Control |||| Control',
  subtitle: 'Device health, incidents and data reception, for IT and support',

  sections: {
    deviceHealth: 'Device health',
    incidents: 'Incidents',
    ingest: 'Data reception and technical reconciliation',
    other: 'Other indicators',
  },

  help: {
    title: 'Control',
    description:
      "The Control page (devices and incidents): device availability and silence, peripheral and consumable faults, incidents with their resolution time, and the data reception gaps that the status page also shows.",
    features: {
      list: 'Every metric carries its coverage/freshness stamp, or the exact remedy when the data is not available.',
    },
    tips: {
      property: 'Switch property at the top left; the default period is the last 30 days.',
    },
  },
};

export default control;
